import { FC } from 'react';

import { Card } from '@hdi-seguros/web-components.card';
import { CoveragesCarSection } from '../CoverageCarSection';
import { MultiplicativeFactorsSection } from '../MultiplicativeFactorsSection';

interface CarQuotationFormByTabProps {
  tabKey: number;
}

export const CarQuotationFormByTab: FC<CarQuotationFormByTabProps> = ({
  tabKey,
}) => (
  <Card>
    <MultiplicativeFactorsSection componentId={String(tabKey)} />

    <CoveragesCarSection tabKey={tabKey} />
  </Card>
);
